// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2zMkL","rootCenter":"LoadMoreObserver_rootCenter__1N4h1","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__22N0o"};